import { CanActivateFn } from '@angular/router';
import { LoginService } from '../services/login.service';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const authGuard: CanActivateFn = (route, state) => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return true;

  const loginService: LoginService = inject(LoginService);

  const existingToken: string | null = localStorage.getItem('user_access_token');

  if (existingToken) {
    return true;
  }

  const tokenFromUrl: string | null = route.queryParams['token'] ?? loginService.extractTokenFromHash();

  if (tokenFromUrl) {
    loginService.loginOauth(tokenFromUrl);
    return true;
  }

  loginService.redirectToLogin();
  return false;
};
